import { Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const DIMMED_OPACITY = 0.5;

export const Root = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "$dimmed",
})<{ $dimmed?: boolean }>(({ $dimmed, theme }) => ({
  width: "100%",
  gap: theme.spacing(0.5),
  padding: theme.spacing(1, 1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  opacity: $dimmed ? DIMMED_OPACITY : 1,
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shorter,
  }),
}));

export const Row = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  flexWrap: "wrap",
  rowGap: theme.spacing(0.5),
  columnGap: theme.spacing(1.5),
}));

export const Item = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.5),
  minWidth: 0,
}));

export const Line = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$color" && prop !== "$dashed",
})<{ $color: string; $dashed: boolean }>(({ $color, $dashed }) => ({
  width: 18,
  flexShrink: 0,
  borderTop: `2px ${$dashed ? "dashed" : "solid"} ${$color}`,
}));

export const ConsensusLine = styled(Box)(({ theme }) => ({
  width: 18,
  flexShrink: 0,
  borderTop: `2px solid ${theme.palette.gold.dark}`,
}));

export const MarketsBadge = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  fontWeight: 500,
  color: theme.palette.text.secondary,
  padding: theme.spacing(0.25, 0.75),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.action.selected,
  whiteSpace: "nowrap",
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const ConsensusLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  color: theme.palette.gold.dark,
  whiteSpace: "nowrap",
}));

export const Caption = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  color: theme.palette.text.disabled,
  whiteSpace: "nowrap",
}));

export const Price = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 700,
  color: theme.palette.text.primary,
  whiteSpace: "nowrap",
}));

export const Divider = styled(Box)(({ theme }) => ({
  width: 1,
  height: 12,
  flexShrink: 0,
  backgroundColor: theme.palette.divider,
}));
